const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/services/orderAndEventsSetupManager.ts';
import Imm from 'immutable';

export const categoriesContainer = {
    imm: Imm.Map<string, any>(),
};

export const getCategories = () => {
    return categoriesContainer.imm;
};
